import { UserShort } from "tm-shared/types";

import { StyledActiveUserSection, StyledSectionTitle } from "../../Styled";
import { MemberCard } from "../MemberCard";

interface ActiveUserSectionProps {
    member: UserShort;
    routeId: string;
    isProcessing: boolean;
    onLoadSchedule: (
        userId: string,
        roleSlug: string,
        routeId?: string,
    ) => void;
    onNavigate: () => void;
}

export const ActiveUserSection = ({
    member,
    routeId,
    isProcessing,
    onLoadSchedule,
    onNavigate,
}: ActiveUserSectionProps) => {
    return (
        <>
            <StyledSectionTitle>Активний маршрут</StyledSectionTitle>
            <StyledActiveUserSection>
                <MemberCard
                    member={member}
                    routeId={routeId}
                    isActive
                    isProcessing={isProcessing}
                    onLoadSchedule={onLoadSchedule}
                    onNavigate={onNavigate}
                />
            </StyledActiveUserSection>
        </>
    );
};
